import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_COMPETITORS_FAILURE, FETCH_COMPETITORS_REQUEST, FETCH_COMPETITORS_SUCCESS } from "../actions/competitorActions";

  
  const initialState = {
    items: [],
    loading: true,
    error: null,
  };
  
  const competitorsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_COMPETITORS_REQUEST:
        return { ...state, loading: true , payload: action.payload};
      case FETCH_COMPETITORS_SUCCESS:
        return { ...state, loading: false, items: action.payload };
      case FETCH_COMPETITORS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
        return { ...state, loading: false, items: [] };  
      default:
        return state;
    }
  };
  
  export default competitorsReducer;
  